// Which VAT treatment a customer or supplier gets in the active company: its posting group (per
// legal entity) decides it. Editors use this to preview 0% lines the server will enforce.
import { type Party, type PostingGroup, useApi, useAuth } from "@keel/core";

export function useZeroVat(party: Party | undefined, kind: "customer" | "supplier"): string | undefined {
  const { company, can } = useAuth();
  const groups =
    useApi<PostingGroup[]>(can("accounting.posting_groups.read") ? "/accounting/posting-groups" : null)
      .data ?? [];
  if (!party) return undefined;
  const code = party.postingGroupByCompany?.[company.id] ?? party.postingGroup;
  const treatment = groups.find((g) => g.kind === kind && g.code === code)?.vatTreatment;
  if (treatment === "reverse_charge")
    return kind === "customer"
      ? "Reverse charge: intra-EU business customer, invoiced at 0% VAT."
      : "Reverse charge: intra-EU purchase, no VAT on the order (you self-account for it).";
  if (treatment === "export")
    return kind === "customer" ? "Export: outside the EU, 0% VAT." : "Export supplier: no VAT on the order.";
  return undefined;
}
